module.exports = __webpack_public_path__ + "img/liz_white.d21fa51c.svg";